export default __webpack_public_path__ + "static/media/AlarmCount.f7c359fd.png";